<template>
  <div style="min-height: 100vh">
    <v-container class="text-center">
      <v-row justify="center" style="min-height: 80vh" align="center">
        <v-col class="col-6" v-if="!error">
          <v-progress-linear
            color="#72AFE7"
            class="mb-2"
            indeterminate
            rounded
            height="5"
          ></v-progress-linear>
          <div style="font-size: 18px">Redirecting...</div>
        </v-col>
        <v-col class="col-6" v-if="error">
          <div style="font-size: 22px; color: red">Error</div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AdminViewService from "@/requests/AdminView/AdminViewService.js";
import ProfileService from "@/requests/Profile/ProfileService";
import { mapGetters, mapActions } from "vuex";
import LanguageService from "@/requests/Language/LanguageService";

export default {
  data: () => ({
    error: false,
  }),
  mounted() {
    this.loginFromAdmin();
  },
  computed: {
    ...mapGetters(["loggedUser"]),
    ...mapGetters(["user"]),
  },
  methods: {
    ...mapActions(["updateInfoLogged"]),
    ...mapActions(["updateInfo"]),
    async loginFromAdmin() {
      var form = new FormData();
      form.append("key", this.$route.params.key);
      await AdminViewService.loginFromAdmin(form)
        .then((response) => {
          this.updateInfoLogged({
            accessToken: response.result.access_token,
            token: response.result.token,
            locale: this.user.locale,
            timeout: 2 * 3600,
          });
          let form = new FormData();
          form.append("language",  this.user.locale);
          form.append("type", process.env.VUE_APP_TYPE);
          LanguageService.changeLang(form)
          ProfileService.getProfile().then((res) => {
            if (
              res.result.is_owner === "0" &&
              process.env.VUE_APP_TYPE === "Business"
            ) {
              res.result.business.forEach((b) => {
                this.updateInfoLogged({
                  firstName: res.result.first_name,
                  lastName: res.result.last_name,
                  isOwner: res.result.is_owner == "1" ? true : false,
                  role_id: b.role_id,
                  phoneCode: res.result.phone_code,
                  email: res.result.email,
                });
              });
            } else if (
              res.result.is_owner === "0" &&
              process.env.VUE_APP_TYPE === "Social"
            ) {
              res.result.social.forEach((s) => {
                console.log("suka", s);
                this.updateInfoLogged({
                  firstName: res.result.first_name,
                  lastName: res.result.last_name,
                  isOwner: res.result.is_owner == "1" ? true : false,
                  role_id: s.role_id,
                  phoneCode: res.result.phone_code,
                });
              });
            } else {
              this.updateInfoLogged({
                firstName: res.result.first_name,
                lastName: res.result.last_name,
                isOwner: res.result.is_owner == "1" ? true : false,
                role_id: "0",
                phoneCode: res.result.phone_code,
                email: res.result.email,
              });
            }
            this.$router.push("/");
          });
          console.log(this.loggedUser);
          //window.location.href = "/"
        })

        .catch(() => {
          this.error = true;
        });
    },
  },
};
</script>